export interface Reference {
  slug: string;
  /** Jméno osoby, která referenci napsala. */
  author: string;
  /** Pozice + firma (zobrazí se pod jménem). */
  role: string;
  /** Krátký výtažek (1–2 věty) — zobrazí se v kartě. */
  excerpt: string;
  /** Plná verze pro detail (volitelně, jinak fallback na excerpt). */
  fullQuote?: string;
  /** Logo firmy (volitelné). */
  logoSrc?: string;
  /**
   * Tmavé jednobarevné logo (tmavá wordmark) → na tmavé kartě by zaniklo, proto
   * ho obarvíme na bílou siluetu. Barevná/světlá loga necháváme beze změny.
   */
  logoInvert?: boolean;
  /** Foto autora (volitelné). */
  photoSrc?: string;
  /** Volitelné konkrétní metriky/úspěchy. */
  metric?: { value: string; label: string };
}

export const REFERENCES: readonly Reference[] = [
  {
    slug: "kamil-antos",
    author: "Mgr. Kamil Antoš, Ph.D.",
    role: "Majitel firmy",
    photoSrc: "/hca-reference/kamil-antos.jpg",
    excerpt:
      "HCA systém managementu mi dal strukturu, myšlení a jistotu v rozhodování. Pro mě nebyli jen poradci, ale partneři.",
    fullQuote:
      "S HCA spolupracuji od roku 2014. V té době jsem už měl manažerskou zkušenost, ale došlo mi, že bez jasného systému nemůžu firmu dál rozvíjet – a nevěděl jsem, jak na to. Ondra mi představil HCA systém managementu, který mi dával smysl. Studiem v následujících letech jsem získal strukturu, myšlení a jistotu v rozhodování. Díky tomu jsem firmu posunul z malého týmu na 23 lidí a rozšířil ji o nové pobočky v Maďarsku (2016) a na Slovensku (2024). Pro mě osobně Ondra a HCA nebyli jen poradci, ale partneři, kteří mi pomohli udělat zásadní kroky a posunout firmu i sebe dál.",
    metric: { value: "3,3×", label: "růst obratu (150 → 500 mil. Kč) za 8 let" },
  },
  {
    slug: "vojtech-stehno",
    author: "Vojtěch Stehno",
    role: "CEO, jednatel a spolumajitel · Foreigners Group",
    photoSrc: "/hca-reference/vojtech-stehno.jpg",
    logoSrc: "/hca-reference/foreigners-logo.svg",
    logoInvert: true,
    excerpt: "HCA posunulo naši firmu na jiný level. Kromě úspěšné firmy mám i čas na rodinu.",
    fullQuote:
      "HCA posunulo naši firmu na jiný level. Ale především díky VIP programu a dalším seminářům a tréninkům jsem schopen jako majitel normálně fungovat a nebýt uhoněný podnikatel, který nestíhá. Takže kromě úspěšné firmy mám i čas na rodinu. Doporučil bych každému podnikateli, ale i nepodnikateli, protože data a nástroje mi dobře slouží i v osobním životě.",
  },
  {
    slug: "daniel-klofac",
    author: "Ing. Daniel Klofáč, Ph.D.",
    role: "Spolumajitel a obchodní ředitel · KLOFÁČ, spol. s r.o.",
    photoSrc: "/hca-reference/daniel-klofac.jpg",
    logoSrc: "/hca-reference/klofac-logo.png",
    logoInvert: true,
    excerpt:
      "Kurz Efektivní vedení obchodního rozhovoru mi výrazně pomohl v uzavírání obchodů. Ondra vždy nabídne praktickou radu nebo jiný pohled na situaci.",
    fullQuote:
      "HCA jsem oslovil na doporučení známého v době, kdy jsem řešil nízkou úspěšnost obchodních jednání. Kurz Efektivní vedení obchodního rozhovoru, vedený Ondrou Křelinou, mi výrazně pomohl v oblasti uzavírání obchodů a zároveň mě motivoval k dalšímu vzdělávání v oblasti soft skills. Při pravidelném setkávání s Ondrou jsem měl možnost konzultovat i konkrétní problémy našeho rodinného podnikání. Ondra vždy dokázal nabídnout praktickou radu, jiný pohled na situaci nebo zajímavý nápad, který měl reálný přínos pro zlepšení fungování firmy. Dosavadní spolupráce mě přesvědčila o kvalitě HCA i jejich lektorů.",
  },
  {
    slug: "petr-nepustil",
    author: "Ing. Petr Nepustil",
    role: "Jednatel · K-net Technical International Group",
    photoSrc: "/hca-reference/petr-nepustil.jpg",
    logoSrc: "/hca-reference/knet-logo.svg",
    excerpt:
      "Spolupráce mi přinesla jasnou představu o tom, jak nastavovat věci tak, aby skutečně fungovaly v praxi.",
    fullQuote:
      "Spolupráce si velmi vážím a byla pro mě přínosná jak po profesní, tak i po osobní stránce. Přinesla mi především jasnou představu o tom, jak nastavovat věci tak, aby skutečně fungovaly v praxi. Osobně mi spolupráce nejvíce pomohla v oblasti komunikace a hlavně v tom, jak jejím prostřednictvím efektivně dosahovat stanovených cílů. Na úrovni firmy byl největší přínos ve správném nastavení pozic a jejich řízení. Spolupráci určitě doporučuji – je postavená na reálných a praktických základech.",
  },
  {
    slug: "ondrej-labuda",
    author: "Ing. Ondřej Labuda",
    role: "CEO · MARAIS, s.r.o.",
    photoSrc: "/hca-reference/ondrej-labuda.jpg",
    logoSrc: "/hca-reference/marais-logo.png",
    excerpt:
      "Pomohlo mi to jasně definovat základní principy, hodnoty a směr fungování. Ondra nutí přemýšlet a klást si správné otázky.",
    fullQuote:
      "Spolupráce s Ondrou mi pomohla hlavně v tom, že jsem si dokázal jasně definovat základní principy, hodnoty a směr fungování. Nešlo o konkrétní rady, ale hlavně o způsob vedení a komunikaci, která člověka nutí přemýšlet a pokládat si správné otázky, a především také upřímné kritické otázky. Právě i díky tomu jsem si dokázal lépe ujasnit další kroky, priority i dlouhodobý směr. Ondru určitě doporučuji každému, kdo potřebuje trošku „nakopnout“ a věci „rozhýbat“.",
  },
  {
    slug: "magda-joyce",
    author: "Magda",
    role: "Joyce — 1-2-3 spojeno",
    photoSrc: "/hca-reference/joyce-magda.jpg",
    logoSrc: "/hca-reference/joyce-logo.svg",
    excerpt:
      "Pomohli jste nám vyjasnit hranice mezi pozicemi a nastavit procesy tak, aby se lidem lépe pracovalo.",
    fullQuote:
      "Naší firmě jste pomohli vyjasnit hranice mezi jednotlivými pozicemi, aby se kolegům lépe pracovalo ve smyslu, kdy a v jaké kvalitě mají předávat svou část práce dalšímu kolegovi. To je pro mě nejdůležitější, aby se lidem lépe pracovalo a dosahovali společných cílů. Vyjasnilo se, jak máme nastavené procesy a postupy, a začali jsme je postupně vylepšovat. Určitě je dobré, aby si každý, bez ohledu na pozici, udělal rekapitulaci sám v sobě: jak se mu pracuje, co chce a může ovlivnit či změnit. A právě to vaše firma umí.",
  },
  {
    slug: "jan-kubik",
    author: "Jan Kubík",
    role: "Ředitel · Casa GREY s.r.o.",
    logoSrc: "/hca-reference/casagrey-logo.png",
    excerpt:
      "S firmou HCA a panem Křelinou jsem byl nadmíru spokojen. Vstřícnost, nadhled a jeho služby jsou v dnešní době ojedinělé.",
    fullQuote:
      "S firmou HCA a panem Křelinou jsem byl nadmíru spokojen. Vstřícnost, nadhled a jeho služby jsou v dnešní době ojedinělé. Mohu jen doporučit.",
  },
  {
    slug: "stepan-heinik",
    author: "Štěpán Heinik",
    role: "CEO a jednatel · Elixeum s.r.o.",
    photoSrc: "/hca-reference/stepan-heinik.jpg",
    logoSrc: "/hca-reference/elixeum-logo.png",
    excerpt:
      "Pomohlo nám pojmenovat věci, které ve firmě cítíte, ale těžko uchopíte — práci s lidmi, motivaci, odpovědnost i způsob řízení.",
    fullQuote:
      "Spolupráce s Ondrou a HCA nám pomohla lépe pojmenovat věci, které ve firmě často cítíte, ale v každodenním provozu je těžké je uchopit – práci s lidmi, motivaci, odpovědnost i způsob řízení. Nešlo o obecné manažerské poučky, ale o praktický a lidský pohled na situace, které reálně ve firmě řešíme. Díky spolupráci jsme začali některé věci vnímat vědoměji, otevřeněji a s větším důrazem na principy než na dojmy. Ondru a HCA bych doporučil všem, kdo chtějí posunout řízení lidí z pocitové roviny do něčeho konkrétního, uchopitelného a použitelného v praxi.",
  },
  {
    slug: "patrik-topic",
    author: "Patrik Topič",
    role: "Majitel · Topič s.r.o.",
    photoSrc: "/hca-reference/patrik-topic.jpg",
    logoSrc: "/hca-reference/topic-logo.svg",
    excerpt:
      "Pomohli mi s organizací firmy a předáním odpovědností. Díky tomu mám čas na majitelské činnosti a firma může růst — investice se několikanásobně vrátila.",
    fullQuote:
      "Mimo mnoho dalšího nám HCA pomohlo hlavně s organizací firmy a předáním odpovědností — to beru jako jeden ze základních kroků k tomu, aby byla firma silná. Dopadem je, že se můžu věnovat majitelským činnostem a firma se může dál vyvíjet a růst. Oceňuji kompetentnost, schopnost zamyslet se nad věcmi a velkou a upřímnou ochotu pomoct. Investice peněz i času se několikanásobně vrátila – ale za mě je druhořadá; nejvíc mi dává ten způsob života, kdy žiju opravdu život majitele. Kdo chce být skutečným šéfem a pánem svého času, měl by projít VIP programem v HCA.",
  },
  {
    slug: "jakub-klecka",
    author: "Jakub Klečka",
    role: "Jednatel a CEO · Kletch",
    logoSrc: "/hca-reference/klecka-logo.png",
    excerpt:
      "Jejich know-how je masakr. Každý seminář dává víc zapadajících koleček do soukolí firmy – i do vztahů. Doporučuju jednoduše proto, že to funguje.",
    fullQuote:
      "Ondru Křelinu a HCA prostě musím doporučit – jejich know-how je masakr. V mojí hlavě každý další seminář nebo workshop dává víc zapadajících koleček do soukolí firmy. A co mě nejvíc baví, funguje to i v jakémkoliv vztahu – všechno souvisí: já, rodina, kolegové, klienti. To vše se mi díky HCA daří lépe chápat, organizovat, komunikovat a jednoduše žít. Doporučil bych je jednoduše proto, že to funguje. A dost podstatná věc, kterou odjinud neznám – jejich práce nekončí podpisem prezenčky, ale tím, že vám ty informace k něčemu byly a pomohly vám něco posunout.",
  },
  {
    slug: "ondrej-klein",
    author: "Ondřej Klein",
    role: "CEO a spolumajitel (2. generace) · JCEE",
    photoSrc: "/hca-reference/ondrej-klein.jpg",
    logoSrc: "/hca-reference/jcee-logo.png",
    excerpt:
      "Oceňuji kvalitní a strukturované vzdělávání, které jde do hloubky a nezůstává jen u teorie. Důraz na praktickou aplikaci má reálný dopad na firmu i lidi.",
    fullQuote:
      "Spolupráci s HCA vnímám velmi pozitivně – oceňuji zejména kvalitní a dobře strukturované vzdělávání, které jde do hloubky témat a nezůstává jen u teorie. Velkou přidanou hodnotou je pro mě důraz na praktickou aplikaci, takže si člověk z každého programu odnese konkrétní věci, které může hned využít v praxi. Díky tomu má spolupráce reálný dopad na fungování firmy i lidí. HCA bych určitě doporučil dál.",
  },
];
